import {API2_SETTINGS} from 'consts/api2'
import BaseStore from './base-store'

class Settings extends BaseStore {
  constructor() {
    super({
      tooltips_enabled: true,
      onboarding: undefined,
      connections_store_id: undefined,
    })
  }


  async doLoad() {
    const settings = await this.getAll()
    settings.forEach(({key, value}) => this._state[key] = value)
  }

  async doSave(_, changed) {
    const to_write = []
    for (const key of changed) to_write.push({key, value: this._state[key]})
    await this.putMany(to_write)
  }

  async getAll() {
    return await this._rest.get(API2_SETTINGS)
  }
  
  async get(name, defval) {
    try {
      const result = await this._rest.get(`${API2_SETTINGS}/${name}`)
      return result.value
    }
    catch(err) {
      if (err.http_code === 404) return defval
      throw err
    }
  }
  
  async getTestAgentTools() {
    return await this._rest.get(API2_SETTINGS + '/test-agent-tools')
  }

  async put(name, value) {
    // TODO: check response object
    return await this._rest.put(API2_SETTINGS, {settings: [{key: name, value: value}]})
  }
  
  async putMany(settings) {
    return await this._rest.put(API2_SETTINGS, {settings})
  }
  
  async remove(name) {
    if (Object.hasOwn(this._state, name)) this._state[name] = undefined
    return await this._rest.delete(`${API2_SETTINGS}/${name}`)
  }
}

const settings = new Settings()
export default settings